<template>
  <div id="main" class="container">
    <form id="tripup-generator" class="form-horizontal" @submit.prevent="sendMessage">
      <div class="row mt-3">
        <div class="col-sm-6 col-md-6">
          <fieldset>
            <legend class="border-bottom">{{ $t('partnerSettings') }}:</legend>
            <div class="form-group row">
              <label for="customerId" class="col-lg-4 col-form-label required">{{
                  $t('partnerId')
                }} <span class="text-danger">*</span></label>
              <div class="col-lg-8">
                <input id="customerId" name="customerId" type="text"
                       v-bind:placeholder="$t('partnerId')"
                       v-model="customerId" v-validate="'required'"
                       class="form-control">
                <div class="invalid-feedback" style="display: block">{{ errors.first('customerId') }}
                </div>
              </div>
            </div>
          </fieldset>
          <widget-start
              :cruiseType="cruiseType"
              @active-tab:changed='handleActiveTabChanged'
              @port:updated='handlePortUpdated'
              @cruise:updated="handleCruiseUpdated"
              :key="selectWidgetKey"
          />
        </div>
        <div class="col-sm-6 col-md-6">
          <fieldset>
            <legend class="border-bottom">{{ $t('containerSettings') }}:</legend>

            <div class="form-group row">
              <label for="shops" class="col-lg-4 col-form-label required">{{
                  $t('shop')
                }}</label>
              <div class="col-lg-8">
                <select id="shops" class="form-control" v-model="shopSelected">
                  <option v-for="(shop, index) in shops" v-bind:value="shop" v-bind:key="index">
                    {{ shop }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="cruise-type" class="col-lg-4 col-form-label required">{{
                  $t('сruiseType')
                }}</label>
              <div class="col-lg-8">
                <select id="cruise-type" class="form-control" v-model="cruiseType">
                  <option v-for="item in cruiseTypes" v-bind:value="item.id" v-bind:key="item.id">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label for="couponCode" class="col-lg-4 col-form-label required">
                {{ $t('couponCode') }}
              </label>
              <div class="col-lg-8">
                <input id="couponCode" name="couponCode" type="text"
                       v-bind:placeholder="$t('couponCode')"
                       v-model="couponCode"
                       class="form-control">
              </div>
            </div>

            <div class="form-group row">
              <label for="channel" class="col-lg-4 col-form-label required">
                {{ $t('channel') }}
              </label>
              <div class="col-lg-8">
                <input id="channel" name="channel" type="text"
                       v-bind:placeholder="$t('channel')"
                       v-model="channel"
                       class="form-control">
              </div>
            </div>
                      <div class="form-group row">
                        <label for="components" class="col-lg-4 col-form-label required">
                          {{ $t('components') }}
                        </label>
                        <div class="col-lg-8">
                          <select id="components" class="form-control" v-model="components" multiple>
                            <option>search</option>
                            <option>itinerary</option>
                            <option>products</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="tags" class="col-lg-4 col-form-label">
                          {{ $t('tags') }}
                        </label>
                        <div class="col-lg-8">
                          <input id="tags" name="tags" type="text"
                                 v-bind:placeholder="$t('tags')"
                                 v-model="tags"
                                 class="form-control">
                          <small id="tagsHelp" class="form-text text-muted">top, sale, new...</small>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="limit" class="col-lg-4 col-form-label">
                          {{ $t('limit') }}
                        </label>
                        <div class="col-lg-8">
                          <input id="limit" name="limit" type="text"
                                 v-bind:placeholder="$t('limit')"
                                 v-model="limit"
                                 class="form-control">
                          <small id="limitHelp" class="form-text text-muted">1, 2, 3...</small>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="destination" class="col-lg-4 col-form-label">
                          {{ $t('destination') }}
                        </label>
                        <div class="col-lg-8">
                          <v-select v-bind:placeholder="$t('destination')"
                                    :options="destinations"
                                    v-model="destination"
                                    label="destination"
                                    :reduce="obj => obj.destination"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <div class="col-lg-12">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="shortProducts"
                                   id="shortProducts" value="1" v-model="shortProducts"/>
                            <label for="shortProducts" class="form-check-label">
                              {{ $t('shortProducts') }}
                            </label>
                          </div>
                        </div>


                        <div class="col-lg-12">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="showTitles"
                                   id="showTitles" value="1" v-model="showTitles"/>
                            <label for="showTitles" class="form-check-label">
                              {{ $t('showTitles') }}
                            </label>
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="hidePort"
                                   id="hidePort" :value="false" v-model="hidePort"/>
                            <label for="hidePort" class="form-check-label">{{
                                $t('hidePort')
                              }}</label>
                          </div>
                        </div>
                      </div>
          </fieldset>
        </div>
      </div>
      <div class="row mt-3">
        <div v-if="customerId !== ''" class="col-sm-12" :key="codeEmbedKey">
          <legend class="border-bottom">{{ $t('yourCodeEmbed') }}:</legend>
          <Prism language="javascript">
            {{ divCode }}
            &lt;script async defer type="text/javascript"
            data-containers="widget-main-tripup"
            src="{{ langService.getUrlWidget() }}/itinerary/js/main.min.js"&gt;&lt;/script&gt;
          </Prism>
        </div>
        <div class="col-sm-12">
          <fieldset>
            <legend class="border-bottom">{{ $t('preview') }}:</legend>
            <preview v-if="activeTabStart === 1"
                     :customer-id="customerId"
                     :coupon-code="couponCode"
                     :channel="channel"
                     :components="components.join(', ')"
                     :portId="portId"
                     :tags="tags"
                     :limit="limit"
                     :destination="destination"
                     :shortProducts="shortProducts"
                     :showTitles="showTitles"
                     :hidePort="hidePort"
                     :shopSelected="shopSelected"
                     :cruiseDate="cruiseDate"
                     :cruiseType="cruiseType"
                     :key="componentKey"/>
            <preview v-if="activeTabStart === 2"
                     :customer-id="customerId"
                     :coupon-code="couponCode"
                     :channel="channel"
                     :components="components.join(', ')"
                     :cruiseShipName="cruiseShipName"
                     :tags="tags"
                     :limit="limit"
                     :destination="destination"
                     :cruiseDate="cruiseDate" :cruiseDuration="cruiseDuration"
                     :shortProducts="shortProducts" :showTitles="showTitles"
                     :hidePort="hidePort"
                     :cruiseType="cruiseType"
                     :shopSelected="shopSelected" :key="componentKey"/>
          </fieldset>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Preview from "./Preview"
import Prism from 'vue-prism-component'
import WidgetStart from "./WidgetStart";
import LangService from '../services/LangService';
import DataService from "../api/SelectService";

export default {
  name: "Main",
  components: {Preview, Prism, WidgetStart},
  data: function () {
    return {
      componentKey: 0,
      selectWidgetKey: 0,
      codeEmbedKey: 0,
      activeTabStart: 1,
      customerId: '',
      shopSelected: LangService.getShop(),
      cruiseType: 'sea',
      cruiseTypes: [
        {id: "all", label: this.$t("allCruises")},
        {id: "sea", label: this.$t("onlySea")},
        {id: "river", label: this.$t("onlyRiver")},
      ],
      shops: [
        'meine-landausfluege.de',
        'meine-landausfluege.ch'
      ],
      couponCode: '',
      channel: '',
      components: ['search', 'itinerary', 'products'],
      destinations: [],
      tags: '',
      limit: null,
      destination: '',
      cruiseShipName: "",
      cruiseDate: '',
      cruiseDuration: null,
      portId: null,
      shortProducts: false,
      showTitles: false,
      hidePort: false,
      langService: LangService
    }
  },
  async mounted() {
    this.destinations = await DataService.getDestinations();
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    selectWidgetForceRender() {
      this.selectWidgetKey += 1;
    },
    codeEmbedKeyRender() {
      this.codeEmbedKey += 1;
    },
    handleActiveTabChanged(data) {
      this.activeTabStart = data.activeTab;
      this.forceRerender();
    },
    handlePortUpdated(data) {
      this.portId = data.widgetPortId;
      this.forceRerender();
    },
    handleCruiseUpdated(data) {
      this.cruiseShipName = data.widgetCruiseShipName;
      this.cruiseDuration = data.widgetCruiseDuration;
      this.cruiseDate = data.widgetCruiseDate;
      this.forceRerender();
    }
  },
  computed: {
    divCode() {
      let result = '<div class="col-md-12" id="widget-main-tripup" data-customer="' + this.customerId + '"';

      if (this.couponCode) result += ' data-coupon="' + this.couponCode + '"';
      if (this.channel) result += ' data-channel="' + this.channel + '"';
      if (this.tags) result += ' data-tags="' + this.tags + '"';
      if (this.limit) result += ' data-limit="' + this.limit + '"';
      if (this.destination) result += ' data-destination="' + this.destination + '"';
      if (this.cruiseType) result += ' data-cruisetype="' + this.cruiseType + '"';

      result += ' data-components="' + this.components.join(', ') + '"';
      if (this.activeTabStart === 1) {
        if (this.portId) result += ' data-port_id="' + this.portId + '"';
      } else {
        if (this.cruiseShipName) result += ' data-ship="' + this.cruiseShipName + '"';
        if (this.cruiseDate) result += ' data-date="' + this.cruiseDate + '"';
        if (this.cruiseDuration) result += ' data-duration="' + this.cruiseDuration + '"';
      }

      result += ' data-shortproducts="' + this.shortProducts + '" data-showtitles="' + this.showTitles + '" data-showport="' + !this.hidePort + '"';

      result += "></div>";
      return result;
    }
  },
  watch: {
    customerId: function () {
      this.forceRerender();
      this.codeEmbedKeyRender()
    },
    shopSelected: async function () {
      LangService.setShop(this.shopSelected);
      this.selectWidgetForceRender();
      this.forceRerender()
    },
    cruiseType: async function () {
      this.forceRerender()
    },
    couponCode: function () {
      this.forceRerender()
    },
    channel: function () {
      this.forceRerender()
    },
    components: function () {
      this.forceRerender()
    },
    limit: function () {
      this.forceRerender()
    },
    tags: function () {
      this.forceRerender()
    },
    destination: function () {
      this.forceRerender()
    },
    shortProducts: function () {
      this.forceRerender()
    },
    showTitles: function () {
      this.forceRerender()
    },
    hidePort: function () {
      this.forceRerender()
    }
  }
}
</script>


<style>
    code {
        white-space: pre-line !important;
    }
</style>
